// Marquinha da mesa de bistrô — usada no header e onde a marca aparecer.
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" role="img" aria-label="La petite table">
      <ellipse cx="32" cy="22" rx="22" ry="7" fill="none" stroke="#c5532f" stroke-width="4" />
      <line x1="32" y1="22" x2="32" y2="48" stroke="#c5532f" stroke-width="4" stroke-linecap="round" />
      <ellipse cx="32" cy="50" rx="11" ry="3.6" fill="none" stroke="#c5532f" stroke-width="4" />
    </svg>
  );
}
